import {
    GET_EXPIREDPASSWORD_USERINFO,
    GET_EXPIREDPASSWORD_USERINFO_SUCCESSED,
    GET_EXPIREDPASSWORD_USERINFO_FAILED,
    UPDATE_EXPIREDPASSWORD_USERINFO,
    UPDATE_EXPIREDPASSWORD_USERINFO_SUCCESSED,
    SAVE_EXPIREDPASSWORD,
    SAVE_EXPIREDPASSWORD_FAILED,
    SAVE_EXPIREDPASSWORD_SUCCESSED
  } from '../actions/actionTypes'
  
  const initialState = {
    data: {currentpassword:null, password:null, confirmpassword:null,refnum:null},
    requesting_get: false,
    requesting_get_successful: false,
    requesting_update:false,
    requesting_update_successful:false,
    requesting_save: false,
    requesting_save_successful: false,
    message: null,
    infoError: null,
    loading_message: "Loading expired password userinfo..."
  }
  
  function expiredPasswordUserInfoReducers(state = initialState, action) {
    switch (action.type) {
      case GET_EXPIREDPASSWORD_USERINFO:
        return Object.assign({}, {
          requesting_get: true,
          requesting_get_successful: false,
          data: Object.assign({}, state.data),
          message: null,
          infoError: null,
          loading_message: "Loading expired password userinfo..."
        })
      case GET_EXPIREDPASSWORD_USERINFO_SUCCESSED:
        return Object.assign({}, {
          requesting_get: false,
          requesting_get_successful: true,
          data: Object.assign({}, action.data),
          message: null,
          infoError: null,
          loading_message: state.loading_message
        })
      case GET_EXPIREDPASSWORD_USERINFO_FAILED:
        return Object.assign({}, {
          requesting_get: false,
          requesting_get_successful: false,
          data: Object.assign({}, state.data),
          message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
          infoError: action.infoError || null,
          loading_message: state.loading_message
        })
  
        //update expired password userinfo
        case UPDATE_EXPIREDPASSWORD_USERINFO:
          return Object.assign({}, {
            requesting_update: true,
            requesting_update_successful: false,
            data: Object.assign({}, state.data),
            message: null,
            infoError: null,
            loading_message: "Updating expired password userinfo..."
          })
        case UPDATE_EXPIREDPASSWORD_USERINFO_SUCCESSED:
          return Object.assign({}, {
            requesting_update: false,
            requesting_update_successful: true,
            data: Object.assign({}, action.data),
            message: null,
            infoError: null,
            loading_message: state.loading_message
          })
        //save change password
        case SAVE_EXPIREDPASSWORD:
          return Object.assign({}, {
            requesting_save: true,
            requesting_save_successful: false,
            data: Object.assign({}, state.data),
            message: null,
            infoError: null,
            loading_message: "Saving expired password..."
          })
        case SAVE_EXPIREDPASSWORD_SUCCESSED:
          return Object.assign({}, {
            requesting_save: false,
            requesting_save_successful: true,
            data: Object.assign({}, action.data,{currentpassword:null, password:null, confirmpassword:null}),
            message: null,
            infoError: null,
            loading_message: state.loading_message
          })
        case SAVE_EXPIREDPASSWORD_FAILED:
          return Object.assign({}, {
            requesting_save: false,
            requesting_save_successful: false,
            data: Object.assign({},state.data),
            message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
            infoError: action.infoError || null,
            loading_message: state.loading_message
          })
      default:
        return state
    }
  }
  
  export default expiredPasswordUserInfoReducers;
  